import React from 'react'
import MarkdownIt from 'markdown-it'
import { useDispatch } from 'react-redux'
import { storeActions } from '../../../store'
import type { MenuItem } from '../../../models/types'
import { ActionType, CurrentSubView, Routes, UIPart } from '../../../models/enums'
import SvgColorChanger from '../../Attachments/Utils/SvgColorChanger'

interface DashboardItemProps extends MenuItem {
  onClick: () => void
}

const md = MarkdownIt({
  breaks: true,
  html: true,
  xhtmlOut: true,
  typographer: true,
  quotes: `""''`
})

const DashboardItem = ({ text, textColor, image, action, onClick }: DashboardItemProps): JSX.Element => {
  const dispatch = useDispatch()

  const handleInternalAction = (value: Record<string, any> | undefined): void => {
    if (value?.name) {
      switch (value.name.toLowerCase()) {
        case 'openlanguage':
          dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.languages))
          break
        case 'openhistory':
          dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.history))
          break
        case 'opentutorial':
          console.log('Open tutorial')
          break
        case 'opennews':
          dispatch(storeActions.view.setRoute(Routes.News))
          break
        case 'openweather':
          dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.weather))
          break
        case 'openemergency':
          dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.emergency))
          break
        case 'fullscreenimage':
          value.url && dispatch(storeActions.utils.setFullScreenImage(value.url))
          break
      }
    }
  }

  const handleClick = (e: React.MouseEvent): void => {
    switch (action.type) {
      case ActionType.message:
        action.value?.text && dispatch(storeActions.directline.sendMessage({ text: action.value.text }))
        break
      case ActionType.event:
        action.value?.name && dispatch(storeActions.directline.sendEvent({ name: action.value.name, value: action.value.value || null }))
        break
      case ActionType.url:
        action.value?.url && window.open(action.value.url, '_blank', 'noopener noreferrer')
        break
      case ActionType.internal:
        handleInternalAction(action.value)
        break
    }

    onClick()
    dispatch(storeActions.utils.setClickedOnUI(UIPart.card))
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div
      className='rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-overflow-hidden'
      style={{
        color: textColor || '#000'
      }}
      onClick={(e) => handleClick(e)}
    >
      {/* Image */}
      <div className='rf-h-6 rf-w-8'>
        {image?.url && (
          <React.Fragment>
            {image.url.indexOf('svg') > -1 ? <SvgColorChanger svgUrl={image.url} height='100%' fillColor={image.color} /> : <img className='rf-h-full' src={image.url} />}
          </React.Fragment>
        )}
      </div>

      {/* Text */}
      <div
        dangerouslySetInnerHTML={{
          __html: md.render(text)
        }}
      />
    </div>
  )
}

export default DashboardItem
